import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Locale-aware navigation helpers. Use these instead of next/link &
// next/navigation so the active language is preserved across pages.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
